import React, { memo } from 'react';
import cls from '../MeasurementsModal.module.css';

export const MeasurementsModalHeader = memo(({ title, children = '' }) => (
    <header className={cls.header}>
        <h1 className={cls.headerTitle}>{title}</h1>
        {children && children}
    </header>
));
